import React, { useEffect } from 'react';

const DEFAULT_GTM_CLEANUP_ROUTES = ['/register', '/verify-otp', '/company-details'];

const GTMHandler = ({
    containerId = 'GTM-MRJ8CHZD',
    scriptId = 'gtm-script-tag',
    noscriptId = 'gtm-noscript-tag',
    cleanupRoutes = DEFAULT_GTM_CLEANUP_ROUTES,
}) => {
    useEffect(() => {
        const w = window;
        const d = document;
        const s = 'script';
        const l = 'dataLayer';

        if (!d.getElementById(scriptId)) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

            const firstScript = d.getElementsByTagName(s)[0];
            const j = d.createElement(s);
            const dl = l !== 'dataLayer' ? `&l=${l}` : '';

            j.async = true;
            j.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}${dl}`;
            j.id = scriptId;

            if (firstScript?.parentNode) firstScript.parentNode.insertBefore(j, firstScript);
            else d.head.insertBefore(j, d.head.firstChild);
        }

        if (!d.getElementById(noscriptId) && d.body) {
            const noscript = d.createElement('noscript');
            noscript.id = noscriptId;
            noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${containerId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
            d.body.insertBefore(noscript, d.body.firstChild);
        }

        return () => {
            const pathname = w.location.pathname;
            const isStillOnTrackedRoute = cleanupRoutes.some(route => pathname.includes(route));

            if (!isStillOnTrackedRoute) {
                const script = d.getElementById(scriptId);
                if (script) script.remove();

                const noscript = d.getElementById(noscriptId);
                if (noscript) noscript.remove();
            }
        };
    }, [cleanupRoutes, containerId, noscriptId, scriptId]);

    return null;
};

export default GTMHandler;
